import { render, staticRenderFns } from "./TemplatesFolderView.vue?vue&type=template&id=52d83976&scoped=true"
import script from "./TemplatesFolderView.vue?vue&type=script&lang=js"
export * from "./TemplatesFolderView.vue?vue&type=script&lang=js"
import style0 from "./TemplatesFolderView.vue?vue&type=style&index=0&id=52d83976&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d83976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d83976')) {
      api.createRecord('52d83976', component.options)
    } else {
      api.reload('52d83976', component.options)
    }
    module.hot.accept("./TemplatesFolderView.vue?vue&type=template&id=52d83976&scoped=true", function () {
      api.rerender('52d83976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplatesFolderView.vue"
export default component.exports